module.exports = __webpack_public_path__ + "img/pellets-pallet.3e4f996.svg";